import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Home from "./pages/home/home";

const appRoutes = [
  {
    path: "/:eventCode",
    element: <Home />,
  },
  {
    path: "/",
    element: <Home />,
  },
];

const AppLayout = () => {
  return (
    <RouterProvider
      router={createBrowserRouter(appRoutes)}
      fallbackElement={<p>Loading...</p>}
    />
  );
};

export default AppLayout;
